import React from 'react';
import { SizeMe } from 'react-sizeme';
import { useTheme } from '@mui/material/styles';
import { getAspectRatioHeight } from '../lib/Media';
import { getNumericSpacing } from '../lib/Styles';

interface CoverDimensions {
  height: number;
  width: number;
}

export interface CoverTileProps {
  children: (dimensions: CoverDimensions) => React.ReactElement;
  disableDebounceRefreshMode?: boolean;
}

/**
 * CoverTile provides a reusable way to implement a cover block with
 * the required ratio resizing constraints.
 *
 * This component includes a resize listener, then be aware when to use it.
 * Consider ReferenceTile as an alternative or a custom implementation.
 */
const CoverTile: React.FC<CoverTileProps> = (props: CoverTileProps) => {
  const theme = useTheme();

  const { children, disableDebounceRefreshMode = false } = props;

  return (
    <SizeMe refreshMode={disableDebounceRefreshMode ? undefined : 'debounce'}>
      {({ size }) => {
        const { width } = size;
        const height = width
          ? getAspectRatioHeight(width)
          : getNumericSpacing(theme, 44);
        return children({ height, width: width ?? 0 });
      }}
    </SizeMe>
  );
};

export default CoverTile;
